import Axios from "./interceptor";
import { appApiBaseUrl } from "./appApiBaseUrl";

const API_URL = appApiBaseUrl + "/api";

const getAssignedClients = async () => {
  const response = await Axios.get(
    API_URL + "/CarePlanWizard/getassignedClients",
  );
  return response;
};

const getAssignedClientProfile = async (clientId) => {
  const response = await Axios.get(
    API_URL + `/CarePlanWizard/get-client-profile/${clientId}`,
  );
  return response;
};

const getClients = async (filters) => {
  const response = await Axios.post(
    API_URL + "/CarePlanWizard/searchclients",
    filters,
  );
  return response;
};

const updateClientNote = async (data) => {
  const response = await Axios.post(
    `${API_URL}/CarePlanWizard/SaveCarePlanClientComment`,
    data,
  );
  return response.data;
};

const getSupportPlanClientLastUpdateInfo = async (carePlanId) => {
  const response = await Axios.get(
    API_URL +
      `/CarePlanAuditLog/getSupportPlanIndividualLastUpdateInfo?carePlanId=${carePlanId}`,
  );
  return response;
};

export {
  getAssignedClients,
  getAssignedClientProfile,
  getClients,
  updateClientNote,
  getSupportPlanClientLastUpdateInfo,
};
